export enum SftpSourceType {
  file = 'file',
  pattern = 'pattern',
}
